"use client"; // This ensures that the component only runs on the client

import { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import {analytics, initializeFirebase} from "@/lib/firebase"; // Assuming Firebase is initialized here

const LogAnalytics = ({ eventName, eventParams }) => {

    if(analytics === undefined) {
        //console.log("J'initialise ");
        initializeFirebase()
    }

    console.log(analytics);

    useEffect(() => {
        // Log the event when the component is mounted
        if (analytics) {
            //console.log("Je passe");
            logEvent(analytics, eventName, eventParams);
        }
    }, [eventName, eventParams]);

    return null; // This component doesn't need to render anything
};

export default LogAnalytics;